import React, { useEffect } from 'react'
import { PlusIcon, ArrowUpTrayIcon, MagnifyingGlassIcon, ArrowLeftIcon } from '@heroicons/react/24/outline'
import PerpageAndDeleteBtn from '../PerpageAndDeleteBtn/PerpageAndDeleteBtn'
import { setCheckedValues, setCurrentUserId, handleOpen, setSearch, setFormData, setCurrentHomeModalKey, setDeleteUpdateYes, setConfirmationModalShow, setDeleteUpdateItem, setCurrentPage, setAddEditDeleteTag, setDeleteUpdateTag } from '../../reducers/contextSlice'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import { DatePicker, Space } from 'antd';

/**
 * Modern page header with title, search, filters, and action buttons.
 * Provides a consistent toolbar across all management pages.
 */
export const SearchAndAddBtn = ({ 
    paginationRequired = true, 
    updateBtn = false, 
    dateButton = false, 
    importBtn = false, 
    addLink = false, 
    isSearch = true, 
    title, 
    customPlaceHolder = '', 
    addBtn = true, 
    addBtnText = "", 
    FilterDropdowns, 
    delBtn, 
    perPageCount, 
    deleteUpdateTag, 
    redirectionBtn = false, 
    resetFilterBtn = false, 
    handleDateChange, 
    section = 'fi' 
}) => {
    const currentUserId = useSelector(state => state.context.currentUserId)
    const deleteUpdateYes = useSelector(state => state.context.deleteUpdateYes)
    const homeScreenSectionData = useSelector(state => state.context.homeScreenSectionData)
    const actionType = 'update-sectionsettings-priority';
    const search = useSelector(state => state.context.search)
    const dispatch = useDispatch()
    const { RangePicker } = DatePicker;
    
    useEffect(() => {
        if (deleteUpdateYes === "update-sectionsettings-priority") {
            let newAry = homeScreenSectionData && homeScreenSectionData?.map((_ele, i) => ({ _id: _ele._id, sectionPriority: _ele.sectionPriority }));
            dispatch(setDeleteUpdateItem({ updates: newAry }));
        }
    }, [deleteUpdateYes, homeScreenSectionData]);


    return (
        <div className={`mb-6 flex items-center flex-wrap gap-4 ${title ? 'justify-between' : 'justify-end'}`}>
            {/* Left section: Title, filters, back button */}
            <div className='flex flex-wrap gap-4 items-center'>
                {currentUserId && (
                    <button 
                        type="button" 
                        aria-label="Go back" 
                        className='p-2 rounded-lg hover:bg-background-hover transition-colors text-text-secondary hover:text-text-primary' 
                        onClick={() => { 
                            dispatch(setCurrentUserId('')); 
                            dispatch(setCheckedValues([])); 
                        }}
                    >
                        <ArrowLeftIcon className='h-5 w-5' />
                    </button>
                )}

                {title && (
                    <div>
                        <h1 className='text-2xl font-semibold text-text-primary tracking-tight'>
                            {title}
                        </h1>
                    </div>
                )}

                {paginationRequired && (
                    <div className='flex flex-wrap gap-2 items-center'>
                        <PerpageAndDeleteBtn 
                            delBtn={delBtn} 
                            resetFilterBtn={resetFilterBtn} 
                            deleteUpdateTag={deleteUpdateTag} 
                            perPageCount={perPageCount} 
                        />
                        {FilterDropdowns && FilterDropdowns}
                    </div>
                )}
            </div>

            {/* Right section: Search + Action buttons */}
            <div className="flex gap-2 flex-wrap items-center">
                {isSearch && (
                    <div className="relative">
                        <MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-text-tertiary pointer-events-none" />
                        <input
                            className="pl-10 pr-4 py-2 w-64 bg-white border border-border rounded-lg 
                                     text-sm text-text-primary placeholder:text-text-tertiary
                                     focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent
                                     transition-all"
                            type="text"
                            aria-label={`Search ${customPlaceHolder !== '' ? customPlaceHolder : title}`}
                            placeholder={`Search ${customPlaceHolder !== '' ? customPlaceHolder : title}...`}
                            value={search}
                            onChange={(e) => { 
                                dispatch(setSearch(e.target.value)); 
                                dispatch(setCurrentPage(1)) 
                            }}
                        />
                    </div>
                )}

                {redirectionBtn && (
                    <button
                        className='px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-lg 
                                 text-sm font-medium transition-colors shadow-sm hover:shadow-md
                                 flex items-center gap-2 whitespace-nowrap'
                        onClick={() => {
                            dispatch(setDeleteUpdateYes(`add`));
                            dispatch(setAddEditDeleteTag(`add`));
                            dispatch(setCurrentHomeModalKey(`add`));
                            dispatch(setFormData({}));
                            dispatch(handleOpen());
                        }}
                    >
                        <PlusIcon className="h-4 w-4" />
                        Redirections
                    </button>
                )}

                {addBtn && (
                    <button
                        className='px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-lg 
                                 text-sm font-medium transition-colors shadow-sm hover:shadow-md
                                 flex items-center gap-2 whitespace-nowrap'
                        onClick={() => {
                            dispatch(setDeleteUpdateYes(`add`));
                            dispatch(setDeleteUpdateTag("add"));
                            dispatch(setAddEditDeleteTag(`add`));
                            dispatch(setCurrentHomeModalKey(`add`));
                            dispatch(setFormData({}));
                            dispatch(handleOpen());
                        }}
                    >
                        <PlusIcon className="h-4 w-4" />
                        Add {addBtnText !== "" ? addBtnText : title}
                    </button>
                )}

                {addLink && (
                    <Link to="/addBlogs">
                        <button
                            onClick={() => {
                                dispatch(setFormData({}));
                            }}
                            className='px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-lg 
                                     text-sm font-medium transition-colors shadow-sm hover:shadow-md
                                     flex items-center gap-2 whitespace-nowrap'
                        >
                            <PlusIcon className="h-4 w-4" />
                            Add New {title}
                        </button>
                    </Link>
                )}

                {updateBtn && (
                    <button
                        className='px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-lg 
                                 text-sm font-medium transition-colors shadow-sm hover:shadow-md
                                 flex items-center gap-2 whitespace-nowrap'
                        onClick={() => {
                            dispatch(setDeleteUpdateYes(actionType));
                            dispatch(setConfirmationModalShow(true))
                        }}
                    >
                        <ArrowUpTrayIcon className="h-4 w-4" />
                        Update
                    </button>
                )}

                {dateButton && (
                    <div className='date-picker-wrapper'>
                        <Space direction="vertical" size={12}>
                            <RangePicker 
                                className="px-4 py-2 rounded-lg border border-border" 
                                renderExtraFooter={() => false}
                                onChange={handleDateChange}
                                inputReadOnly
                            />
                        </Space>
                    </div>
                )}

                {importBtn && (
                    <button
                        className='px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-lg 
                                 text-sm font-medium transition-colors shadow-sm hover:shadow-md
                                 flex items-center gap-2 whitespace-nowrap'
                        onClick={() => {
                            dispatch(setDeleteUpdateYes(`add`));
                            dispatch(setAddEditDeleteTag(`add`));
                            dispatch(setCurrentHomeModalKey(`add`));
                            dispatch(setFormData({}));
                            dispatch(handleOpen());
                        }}
                    >
                        <ArrowUpTrayIcon className="h-4 w-4" />
                        Import
                    </button>
                )}
            </div>
        </div>
    )
}

export default SearchAndAddBtn